<template>
  <div>
    <inline-editor
      v-if="editing"
      :value="label"
      placeholder="Enter name"
      :max-length="maxLength"
      :style="{ width: '250px'}"
      @apply="onLabelChange"
      @cancel="onLabelCancel"
    />
    <md-menu
      v-show="!editing"
      md-size="medium"
      class="tab-dropdown"
      :class="{ 'selected': selected }"
      md-align-trigger
      @md-opened="onMenuOpened"
    >
      <md-button class="tab-button" md-menu-trigger :aria-label="`${label} tab dropdown`" data-testid="tab-dropdown-button">
        <md-icon v-if="icon" :md-src="icon" />
        {{ prefix + (label || '') }}
        <md-icon>arrow_drop_down</md-icon>
      </md-button>

      <md-menu-content data-testid="dropdown-menu-container">
        <md-menu-item
          v-for="item in items"
          :key="item.key"
          class="dropdown-menu-item"
          :aria-label="`${item.label} menu item`"
          data-testid="dropdown-menu-item"
          @click="onItemClick(item)"
        >
          {{ item.label }}
        </md-menu-item>
        <md-divider
          v-if="showRename || showRemove"
        />
        <md-menu-item
          v-if="showRename"
          class="dropdown-menu-item"
          aria-label="Rename"
          data-testid="rename-menu-item"
          @click="onItemRename"
        >
          <span>Rename</span>
        </md-menu-item>
        <md-menu-item
          v-if="showRemove"
          class="dropdown-menu-item"
          aria-label="Remove"
          data-testid="remove-menu-item"
          @click="onItemRemove"
        >
          <span>Remove</span>
          <md-icon>delete</md-icon>
        </md-menu-item>
      </md-menu-content>
    </md-menu>
  </div>
</template>

<script>
import InlineEditor from '../common/InlineEditor.vue';

export default {
  name: 'tab-dropdown',
  components: {
    InlineEditor
  },
  props: {
    prefix: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Boolean,
      default: false
    },
    showRename: {
      type: Boolean,
      default: false
    },
    showRemove: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 30
    }
  },
  data() {
    return {
      editing: false,
    }
  },
  methods: {
    onMenuOpened() {
      this.$emit('selectMenu');
    },
    onItemClick(item) {
      this.$emit('selectItem', item.key);
    },
    onItemRename() {
      this.editing = !this.editing;
    },
    onItemRemove() {
      this.$emit('removeItem');
    },
    onLabelChange(value) {
      this.editing = false;
      this.$emit('renameLabel', value);
    },
    onLabelCancel() {
      this.editing = false;
    }
  }
}
</script>

<style scoped>
.tab-dropdown.selected {
  border-bottom: 2px solid #84B2FF;
}
.tab-button {
  font-size: 16px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: 4px 6px;
}

.tab-button >>> .md-button-content {
  display: flex;
  align-items: center;
}

.tab-button .md-icon {
  margin-right: 4px;
}

.dropdown-menu-item {
  cursor: pointer;
}
.dropdown-menu-item:hover {
  background-color: #e1e1e1;
}
</style>